import { AppBaseLinkKind, AppBaseLinkProps } from './AppBaseLinkKind'

export type AppExternalLinkProps = AppBaseLinkProps

export function AppExternalLink(props: AppExternalLinkProps) {
  return <AppBaseLinkKind {...props} />
}
